module.exports = __webpack_public_path__ + "static/media/conversation_icon.d449b765.svg";